module.exports = __webpack_public_path__ + "img/59.bb194f61.jpg";